export const ADMIN_LOGIN_ACTION = "AdminLoginAction";
